export default "__VITE_ASSET__1LbrBimz__"